<div
  class="pointer-events-auto absolute z-[100] flex flex-col items-end"
  [class]="state.positionClass"
  style="pointer-events: auto"
>
  <div
    #overviewRef
    class="z-[2] h-[170px] w-full rounded bg-white shadow-sm"
    [ngClass]="state.isOverviewActive ? 'visible mb-1 block opacity-100' : 'invisible hidden opacity-0'"
  ></div>
  <div class="flex h-[36px] items-center overflow-hidden rounded-md bg-white shadow-sm">
    <button
      class="flex h-9 w-9 items-center justify-center text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
      [class.bg-gray-100]="state.isOverviewActive"
      (click)="toggleOverview()"
      [matTooltip]="state.isOverviewActive ? 'Hide Overview' : 'Show Overview'"
      [matTooltipPosition]="'below'"
    >
      <dojo-icon [icon]="'rectangle'"></dojo-icon>
    </button>
    <div class="h-6 w-px bg-gray-200"></div>
    <button
      class="flex h-9 w-9 items-center justify-center text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
      (click)="fitToScreen()"
      [matTooltip]="'Fit to Screen'"
      [matTooltipPosition]="'below'"
    >
      <dojo-icon [icon]="'arrows-left-right-to-line'"></dojo-icon>
    </button>
    <div class="h-6 w-px bg-gray-200"></div>
    <button
      class="flex h-9 w-9 items-center justify-center text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
      [disabled]="state.zoomButtonsDisabled.out"
      [matTooltip]="state.zoomButtonsDisabled.out ? '' : 'Zoom out'"
      [matTooltipPosition]="'below'"
      (click)="zoomOut()"
    >
      <dojo-icon [icon]="'search-minus'"></dojo-icon>
    </button>
    <button
      class="aligner group h-[40px] w-[52px]"
      [disabled]="state.zoomButtonsDisabled.full"
      [matTooltip]="state.zoomButtonsDisabled.full ? '' : 'Zoom to 100%'"
      [matTooltipPosition]="'below'"
      (click)="zoomFull()"
    >
      <span
        class="text-typography-primary dark:font-medium-dark text-title-xs rounded px-1 py-1 font-medium group-hover:bg-gray-200"
        >{{ state.diagramScaleFormatted }}</span
      >
    </button>
    <button
      class="flex h-9 w-9 items-center justify-center text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
      [disabled]="state.zoomButtonsDisabled.in"
      [matTooltip]="state.zoomButtonsDisabled.in ? '' : 'Zoom in'"
      [matTooltipPosition]="'below'"
      (click)="zoomIn()"
    >
      <dojo-icon [icon]="'search-plus'"></dojo-icon>
    </button>
  </div>
</div>
